import { IconPropsType } from '..';

export const InstagramOutlinedIcon = ({ ...props }: IconPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    {...props}
  >
    <path
      d="M41.4744 21C41.4744 9.9543 32.5201 1 21.4744 1C10.4287 1 1.47437 9.9543 1.47437 21C1.47437 32.0457 10.4287 41 21.4744 41C32.5201 41 41.4744 32.0457 41.4744 21Z"
      stroke="#961B47"
      strokeWidth="1.04849"
      strokeMiterlimit="10"
    />
    <path
      d="M25.2068 30.5726H17.7415C14.4912 30.5726 11.8438 27.9251 11.8438 24.6748V17.2095C11.8438 13.9592 14.4912 11.3118 17.7415 11.3118H25.2068C28.4571 11.3118 31.1046 13.9592 31.1046 17.2095V24.6748C31.1046 27.9251 28.4571 30.5726 25.2068 30.5726ZM17.7415 12.7587C15.2828 12.7587 13.2854 14.7561 13.2854 17.2148V24.68C13.2854 27.1388 15.2828 29.1361 17.7415 29.1361H25.2068C27.6655 29.1361 29.6629 27.1388 29.6629 24.68V17.2148C29.6629 14.7561 27.6655 12.7587 25.2068 12.7587H17.7415Z"
      fill="#961B47"
    />
    <path
      d="M21.4745 25.8176C18.7904 25.8176 16.6042 23.6315 16.6042 20.9474C16.6042 18.2633 18.7904 16.0771 21.4745 16.0771C24.1586 16.0771 26.3447 18.2633 26.3447 20.9474C26.3447 23.6315 24.1586 25.8176 21.4745 25.8176ZM21.4745 17.5503C19.6029 17.5503 18.0774 19.0758 18.0774 20.9474C18.0774 22.819 19.6029 24.3445 21.4745 24.3445C23.3461 24.3445 24.8716 22.819 24.8716 20.9474C24.8716 19.0758 23.3461 17.5503 21.4745 17.5503Z"
      fill="#961B47"
    />
    <path
      d="M28.1479 15.5426C28.1479 16.2451 27.5818 16.8113 26.8793 16.8113C26.1768 16.8113 25.6106 16.2451 25.6106 15.5426C25.6106 14.8401 26.1768 14.2739 26.8793 14.2739C27.5818 14.2739 28.1479 14.8401 28.1479 15.5426Z"
      fill="#961B47"
    />
  </svg>
);
